<script lang="ts" setup>
import { translate } from '@hantecmarket/widget-core'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { getLanguage } from '@/helpers/language-helper'
import { __ } from '@/utils/utils'

import type { Breadcrumb } from '@/components/BreadcrumbsElement/BreadcrumbsElement.types'

const route = useRoute()
const siteUrl = `${document.location.origin}/`
const lang: string =
  getLanguage() !== '' && getLanguage() !== 'undefined' && getLanguage() !== 'en'
    ? getLanguage() + '/'
    : ''

const breadcrumbs = computed<Breadcrumb[]>(() => {
  const matchedRoutes = route.matched
  const routeSlugs = route.path.split('/')
  const routeSlug = routeSlugs[routeSlugs.length - 2]

  return matchedRoutes.reduce<Breadcrumb[]>((acc, matchedRoute) => {
    const routeName = (matchedRoute?.name as string) || ''

    const breadcrumbLabel: any = matchedRoute.meta.breadcrumbLabel

    let parentLabel = ''
    let childLabel = ''
    let parentRoute: any = ''

    if (typeof breadcrumbLabel === 'object' && breadcrumbLabel !== null) {
      parentLabel =
        breadcrumbLabel?.parent ||
        routeName.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())
      childLabel =
        breadcrumbLabel?.child ||
        routeName.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())
      if (matchedRoute.meta.breadcrumbRoute) {
        parentRoute = siteUrl + lang + matchedRoute.meta.breadcrumbRoute + routeSlug + '/'
      }
    } else {
      childLabel =
        (breadcrumbLabel as string) ||
        routeName.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())
    }

    if (parentRoute.includes('tools/tools')) {
      parentRoute = siteUrl + lang + 'tools' + '/'
    }

    if (parentLabel || parentRoute) {
      acc.push({
        label: parentLabel,
        to: parentRoute
      })
    }

    if (childLabel) {
      acc.push({
        label: childLabel,
        to: ''
      })
    }
    return acc
  }, [])
})
</script>

<template>
  <nav aria-label="breadcrumb">
    <ol class="gap-[2px] flex self-start lg:pl-0 pl-[10px] lg:pt-0 pt-[20px]">
      <li class="text-red-150">
        <a :href="`${siteUrl}${lang}`" class="text-red-150">{{ __('Home') }}</a>
      </li>

      <li class="text-white">&gt;</li>
      <template v-for="(item, idx) in breadcrumbs" :key="item?.to || idx">
        <li v-if="idx" class="text-white">&gt;</li>

        <li
          :class="{
            'text-red-150': idx !== breadcrumbs.length - 1 && item?.to,
            'text-white': idx === breadcrumbs.length - 1 || !item?.to
          }"
          v-bind:aria-current="idx === breadcrumbs.length - 1 ? 'page' : (null as any)"
        >
          <template v-if="item?.to">
            <a :href="item?.to">{{ translate(item?.label) }}</a>
          </template>
          <template v-else>
            {{ translate(item?.label) }}
          </template>
        </li>
      </template>
    </ol>
  </nav>
</template>
